(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["category-cars-swiper-freemode"] && !Shopify.designMode) return;
  try {
    
(function () {
  // 二重初期化・破棄済みインスタンスへの誤アクセスを防ぐための管理用マーカー
  var INIT_TOKEN_ATTR = 'data-freeswiper-token';
  var tokenCounter = 0;

  function initSwiperCore(el) {
    var wrapper = el.closest('.cat-card-swiper-free');
    if (!wrapper) return;

    // 既存インスタンスがあれば先に破棄（テーマエディタでの再描画・並び替え後の多重初期化対策）
    if (el.swiper) {
      try {
        el.swiper.destroy(true, true);
      } catch (e) {
        /* 既に破棄済み等は無視 */
      }
    }

    tokenCounter += 1;
    var myToken = String(tokenCounter);
    el.setAttribute(INIT_TOKEN_ATTR, myToken);

    var scrollbarEl = wrapper.querySelector('.cat-card-swiper-free__scrollbar');

    // ? AJAXでDOMが差し替わった直後はレイアウト未確定のことがあるため、
    //    2フレーム待ってから初期化（幅0での誤初期化＝「1枚しか表示されない」不具合の対策）
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        // 待っている間に、この要素がさらに新しい初期化に置き換えられていないか確認
        if (el.getAttribute(INIT_TOKEN_ATTR) !== myToken) return;
        if (!el.isConnected) return; // 待っている間にDOMから消えていたら何もしない

        buildSwiper(el, wrapper, scrollbarEl);
      });
    });
  }

  function buildSwiper(el, wrapper, scrollbarEl) {
    if (typeof Swiper === 'undefined') return;

    var swiper = new Swiper(el, {
        // ? ループ・オートスライドなし
        loop: false,
        autoplay: false,

        // ? freeMode：慣性つきの自由スクロール（スナップさせない）
        freeMode: {
          enabled: true,
          sticky: false
        },
        grabCursor: true,

        speed: 400,
        spaceBetween: 20,

        // ? centeredSlidesは使わない＝1枚目が左端フラットで始まる
        centeredSlides: false,
        slidesPerView: 1.5,

        breakpoints: {
          769: {
            slidesPerView: 3,
            spaceBetween: 5
          }
        },

        // ? ページネーションドットの代わりに横スクロールバー
        scrollbar: {
          el: scrollbarEl,
          draggable: true,
          hide: false,
          snapOnRelease: false
        },

        navigation: {
          nextEl: wrapper.querySelector('.swiper-button-next'),
          prevEl: wrapper.querySelector('.swiper-button-prev')
        },

        watchSlidesProgress: true,
        observeParents: true,
        observer: true,

      on: {
        init: function () {
          var self = this;
          requestAnimationFrame(function () {
            // 待っている間に破棄されていたら何もしない（破棄済みインスタンスへのupdate呼び出し防止）
            if (self.destroyed) return;
            self.update();
          });
        }
      }
    });
  }

  // root配下（省略時はdocument全体）の対象スライダーをすべて初期化する
  function initSwiperInScope(root) {
    if (typeof Swiper === 'undefined') return;
    var scope = root && root.querySelectorAll ? root : document;

    scope.querySelectorAll('.cat-card-swiper-free__core').forEach(function (el) {
      initSwiperCore(el);
    });
  }

  // root配下のスライダーを明示的に破棄する（テーマエディタでセクションが差し替え／削除される直前用）
  function destroySwiperInScope(root) {
    var scope = root && root.querySelectorAll ? root : document;

    scope.querySelectorAll('.cat-card-swiper-free__core').forEach(function (el) {
      if (el.swiper) {
        try {
          el.swiper.destroy(true, true);
        } catch (e) {
          /* 既に破棄済み等は無視 */
        }
      }
    });
  }

  function ensureSwiperAssetsThenInit(root) {
    if (window.Swiper) {
      initSwiperInScope(root);
      return;
    }

    var cssHref = 'https://cdn.jsdelivr.net/npm/swiper@9/swiper-bundle.min.css';
    if (!document.querySelector('link[href*="swiper-bundle.min.css"]')) {
      var link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = cssHref;
      document.head.appendChild(link);
    }

    var jsSrc = 'https://cdn.jsdelivr.net/npm/swiper@9/swiper-bundle.min.js';
    if (!document.querySelector('script[src*="swiper-bundle.min.js"]')) {
      var s = document.createElement('script');
      s.src = jsSrc;
      s.defer = true;
      s.onload = function () {
        initSwiperInScope(); // 初回ロードはページ全体を対象
      };
      document.head.appendChild(s);
    } else {
      if (typeof Swiper !== 'undefined') initSwiperInScope(root);
      else window.addEventListener('load', function () { initSwiperInScope(root); });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      ensureSwiperAssetsThenInit(); // 初回ロードはページ全体を対象
    });
  } else {
    ensureSwiperAssetsThenInit();
  }

  // ? テーマエディタ対応：
  //   「変更・選択されたセクションだけ」を対象に再初期化することで、
  //   ページ内の他のスライダーを巻き込んで壊さないようにする。
  document.addEventListener('shopify:section:load', function (event) {
    ensureSwiperAssetsThenInit(event.target);
  });
  document.addEventListener('shopify:section:select', function (event) {
    ensureSwiperAssetsThenInit(event.target);
  });
  document.addEventListener('shopify:block:select', function (event) {
    // ブロック（スライド）選択時にサイズがズレることがあるため、所属セクションのみ更新
    var section = event.target && event.target.closest ? event.target.closest('[id^="shopify-section-"]') : null;
    if (section) ensureSwiperAssetsThenInit(section);
  });

  // セクションがテーマエディタ上で削除／差し替えられる直前に、古いインスタンスを明示的に破棄
  document.addEventListener('shopify:section:unload', function (event) {
    destroySwiperInScope(event.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["category-cars-swiper"] && !Shopify.designMode) return;
  try {
    
(function () {
  function buildBullets(pagEl, originalCount, swiper) {
    if (!pagEl || !originalCount || !swiper) return;

    pagEl.innerHTML = '';

    for (var i = 0; i < originalCount; i++) {
      var b = document.createElement('span');
      b.className = 'swiper-pagination-bullet';
      b.setAttribute('data-bullet-index', String(i));

      b.addEventListener('click', function () {
        var idx = parseInt(this.getAttribute('data-bullet-index'), 10);
        if (isNaN(idx)) return;
        swiper.slideToLoop(idx);
      });

      pagEl.appendChild(b);
    }
  }

  function syncBullets(pagEl, activeIndex) {
    if (!pagEl) return;

    var bullets = pagEl.querySelectorAll('.swiper-pagination-bullet');
    if (!bullets || bullets.length === 0) return;

    for (var i = 0; i < bullets.length; i++) {
      bullets[i].classList.remove('swiper-pagination-bullet-active');
    }
    if (bullets[activeIndex]) {
      bullets[activeIndex].classList.add('swiper-pagination-bullet-active');
    }
  }

  function getRealIndexByDataAttr(swiper) {
    if (!swiper || !swiper.slides || swiper.activeIndex == null) return 0;

    var activeSlide = swiper.slides[swiper.activeIndex];
    if (!activeSlide) return 0;

    var v = activeSlide.getAttribute('data-slide-index');
    var n = parseInt(v, 10);

    return isNaN(n) ? 0 : n;
  }

  function initSwiperForAll() {
    if (typeof Swiper === 'undefined') return;

    document.querySelectorAll('.cat-card-swiper__core').forEach(function (el) {
      var wrapper = el.closest('.cat-card-swiper');
      if (!wrapper) return;

      if (el.swiper) {
        el.swiper.destroy(true, true);
      }

      var slideCount = el.querySelectorAll('.swiper-slide').length;
      var originalCount = parseInt(wrapper.getAttribute('data-original-count'), 10) || 0;

      // ✅ 無限ループ必須：2枚以上ならloop（1枚はloop不可）
      var useLoop = slideCount >= 2;

      var pagEl = wrapper.querySelector('.cat-card-swiper__pagination');
      if (pagEl) {
        pagEl.innerHTML = '';
      }

      var swiper = new Swiper(el, {
        loop: useLoop,
        speed: 400,

        spaceBetween: 20,

        autoplay: useLoop
          ? {
              delay: 5000,
              disableOnInteraction: false,
              pauseOnMouseEnter: true
            }
          : false,

        centeredSlides: true,
        slidesPerView: 1.5,

        breakpoints: {
          769: {
            slidesPerView: 3,
            centeredSlides: false,
            spaceBetween: 5
          }
        },

        // ✅ Swiper標準のpagination生成は使わず、自前でbulletを生成する
        pagination: {
          el: pagEl,
          clickable: false
        },

        navigation: {
          nextEl: wrapper.querySelector('.swiper-button-next'),
          prevEl: wrapper.querySelector('.swiper-button-prev')
        },

        watchSlidesProgress: true,
        observeParents: true,
        observer: true,

        on: {
          init: function () {
            var self = this;

            // ✅ loop安定化
            if (useLoop) {
              self.params.loopedSlides = slideCount;
              self.params.loopAdditionalSlides = 2;
            }

            // ✅ bulletを元枚数だけ生成
            buildBullets(pagEl, originalCount, self);

            // ✅ 初期active同期
            var real = getRealIndexByDataAttr(self);
            syncBullets(pagEl, real);

            setTimeout(function () {
              self.update();
            }, 0);
          },

          slideChange: function () {
            var self = this;
            var real = getRealIndexByDataAttr(self);
            syncBullets(pagEl, real);
          }
        }
      });
    });
  }

  function ensureSwiperAssetsAndInit() {
    if (window.Swiper) {
      initSwiperForAll();
      return;
    }

    var cssHref = 'https://cdn.jsdelivr.net/npm/swiper@9/swiper-bundle.min.css';
    if (!document.querySelector('link[href*="swiper-bundle.min.css"]')) {
      var link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = cssHref;
      document.head.appendChild(link);
    }

    var jsSrc = 'https://cdn.jsdelivr.net/npm/swiper@9/swiper-bundle.min.js';
    if (!document.querySelector('script[src*="swiper-bundle.min.js"]')) {
      var s = document.createElement('script');
      s.src = jsSrc;
      s.defer = true;
      s.onload = initSwiperForAll;
      document.head.appendChild(s);
    } else {
      if (typeof Swiper !== 'undefined') initSwiperForAll();
      else window.addEventListener('load', initSwiperForAll);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ensureSwiperAssetsAndInit);
  } else {
    ensureSwiperAssetsAndInit();
  }

  document.addEventListener('shopify:section:load', function () {
    ensureSwiperAssetsAndInit();
  });
  document.addEventListener('shopify:section:select', function () {
    ensureSwiperAssetsAndInit();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contact-form"]) return;
  try {
    
  (() => {
    const select = document.getElementById('ContactForm--details');
    if (!select) return;

    const orderWrap = document.getElementById('ContactForm-orderid-wrapper');
    const productWrap = document.getElementById('ContactForm-product_name-wrapper');
    const orderInput = orderWrap ? orderWrap.querySelector('input') : null;
    const productInput = productWrap ? productWrap.querySelector('input') : null;

    const setVisible = (wrap, input, visible) => {
      if (!wrap) return;
      if (visible) {
        wrap.classList.remove('is-hidden');
        wrap.removeAttribute('hidden');
      } else {
        wrap.classList.add('is-hidden');
        wrap.setAttribute('hidden', 'hidden');
      }
      if (input) input.disabled = !visible;
    };

    const toggle = () => {
      const option = select.options[select.selectedIndex];
      const needsExtra = option && option.dataset.type === '1';
      setVisible(orderWrap, orderInput, needsExtra);
      setVisible(productWrap, productInput, needsExtra);
    };

    select.addEventListener('change', toggle);
    toggle();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fv-banner-swiper-amiur"] && !Shopify.designMode) return;
  try {
    
(function () {
  // 二重初期化・破棄済みインスタンスへの誤アクセスを防ぐための管理用マーカー
  var INIT_TOKEN_ATTR = 'data-fvswiper-token';
  var tokenCounter = 0;

  function initSwiperCore(el) {
    var wrapper = el.closest('.fv-banner-swiper');
    if (!wrapper) return;

    // 既存インスタンスがあれば先に破棄（テーマエディタでの再描画・並び替え後の多重初期化対策）
    if (el.swiper) {
      try {
        el.swiper.destroy(true, true);
      } catch (e) {
        /* 既に破棄済み等は無視 */
      }
    }

    tokenCounter += 1;
    var myToken = String(tokenCounter);
    el.setAttribute(INIT_TOKEN_ATTR, myToken);

    var paginationEl = wrapper.querySelector('.fv-banner-swiper__pagination');

    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        if (el.getAttribute(INIT_TOKEN_ATTR) !== myToken) return;
        if (!el.isConnected) return;

        buildSwiper(el, paginationEl);
      });
    });
  }

  function buildSwiper(el, paginationEl) {
    if (typeof Swiper === 'undefined') return;

    var slideCount = el.querySelectorAll('.swiper-slide').length;
    var useLoop = slideCount >= 2;

    new Swiper(el, {
      loop: useLoop,
      autoplay: useLoop
        ? {
            delay: 4000,
            disableOnInteraction: false,
            pauseOnMouseEnter: true
          }
        : false,

      speed: 600,
      slidesPerView: 1,
      spaceBetween: 0,

      // スライド間で画像の縦横比が異なってもコンテナ高さが自動追従する
      autoHeight: true,

      pagination: {
        el: paginationEl,
        clickable: true
      },

      watchSlidesProgress: true,
      observeParents: true,
      observer: true,
      observeSlideChildren: true,

      on: {
        init: function () {
          var self = this;
          requestAnimationFrame(function () {
            if (self.destroyed) return;
            self.update();
          });
        }
      }
    });
  }

  // root配下（省略時はdocument全体）の対象スライダーをすべて初期化する
  function initSwiperInScope(root) {
    if (typeof Swiper === 'undefined') return;
    var scope = root && root.querySelectorAll ? root : document;

    scope.querySelectorAll('.fv-banner-swiper__core').forEach(function (el) {
      initSwiperCore(el);
    });
  }

  // root配下のスライダーを明示的に破棄する（テーマエディタでセクションが差し替え／削除される直前用）
  function destroySwiperInScope(root) {
    var scope = root && root.querySelectorAll ? root : document;

    scope.querySelectorAll('.fv-banner-swiper__core').forEach(function (el) {
      if (el.swiper) {
        try {
          el.swiper.destroy(true, true);
        } catch (e) {
          /* 既に破棄済み等は無視 */
        }
      }
    });
  }

  function ensureSwiperAssetsThenInit(root) {
    if (window.Swiper) {
      initSwiperInScope(root);
      return;
    }

    var cssHref = 'https://cdn.jsdelivr.net/npm/swiper@9/swiper-bundle.min.css';
    if (!document.querySelector('link[href*="swiper-bundle.min.css"]')) {
      var link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = cssHref;
      document.head.appendChild(link);
    }

    var jsSrc = 'https://cdn.jsdelivr.net/npm/swiper@9/swiper-bundle.min.js';
    if (!document.querySelector('script[src*="swiper-bundle.min.js"]')) {
      var s = document.createElement('script');
      s.src = jsSrc;
      s.defer = true;
      s.onload = function () {
        initSwiperInScope(); // 初回ロードはページ全体を対象
      };
      document.head.appendChild(s);
    } else {
      if (typeof Swiper !== 'undefined') initSwiperInScope(root);
      else window.addEventListener('load', function () { initSwiperInScope(root); });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      ensureSwiperAssetsThenInit();
    });
  } else {
    ensureSwiperAssetsThenInit();
  }

  // テーマエディタ対応：変更・選択されたセクションだけを対象に再初期化する
  document.addEventListener('shopify:section:load', function (event) {
    ensureSwiperAssetsThenInit(event.target);
  });
  document.addEventListener('shopify:section:select', function (event) {
    ensureSwiperAssetsThenInit(event.target);
  });
  document.addEventListener('shopify:block:select', function (event) {
    var section = event.target && event.target.closest ? event.target.closest('[id^="shopify-section-"]') : null;
    if (section) ensureSwiperAssetsThenInit(section);
  });

  // セクションがテーマエディタ上で削除／差し替えられる直前に、古いインスタンスを明示的に破棄
  document.addEventListener('shopify:section:unload', function (event) {
    destroySwiperInScope(event.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fv-banner-swiper-lawgy"] && !Shopify.designMode) return;
  try {
    
(function () {
  // 二重初期化・破棄済みインスタンスへの誤アクセスを防ぐための管理用マーカー
  var INIT_TOKEN_ATTR = 'data-fvswiper-token';
  var tokenCounter = 0;

  function initSwiperCore(el) {
    var wrapper = el.closest('.fv-banner-swiper');
    if (!wrapper) return;

    // 既存インスタンスがあれば先に破棄（テーマエディタでの再描画・並び替え後の多重初期化対策）
    if (el.swiper) {
      try {
        el.swiper.destroy(true, true);
      } catch (e) {
        /* 既に破棄済み等は無視 */
      }
    }

    tokenCounter += 1;
    var myToken = String(tokenCounter);
    el.setAttribute(INIT_TOKEN_ATTR, myToken);

    var paginationEl = wrapper.querySelector('.fv-banner-swiper__pagination');

    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        if (el.getAttribute(INIT_TOKEN_ATTR) !== myToken) return;
        if (!el.isConnected) return;

        buildSwiper(el, paginationEl);
      });
    });
  }

  function buildSwiper(el, paginationEl) {
    if (typeof Swiper === 'undefined') return;

    var slideCount = el.querySelectorAll('.swiper-slide').length;
    var useLoop = slideCount >= 2;

    new Swiper(el, {
      loop: useLoop,
      autoplay: useLoop
        ? {
            delay: 4000,
            disableOnInteraction: false,
            pauseOnMouseEnter: true
          }
        : false,

      speed: 600,
      slidesPerView: 1,
      spaceBetween: 0,

      // スライド間で画像の縦横比が異なってもコンテナ高さが自動追従する
      autoHeight: true,

      pagination: {
        el: paginationEl,
        clickable: true
      },

      watchSlidesProgress: true,
      observeParents: true,
      observer: true,
      observeSlideChildren: true,

      on: {
        init: function () {
          var self = this;
          requestAnimationFrame(function () {
            if (self.destroyed) return;
            self.update();
          });
        }
      }
    });
  }

  // root配下（省略時はdocument全体）の対象スライダーをすべて初期化する
  function initSwiperInScope(root) {
    if (typeof Swiper === 'undefined') return;
    var scope = root && root.querySelectorAll ? root : document;

    scope.querySelectorAll('.fv-banner-swiper__core').forEach(function (el) {
      initSwiperCore(el);
    });
  }

  // root配下のスライダーを明示的に破棄する（テーマエディタでセクションが差し替え／削除される直前用）
  function destroySwiperInScope(root) {
    var scope = root && root.querySelectorAll ? root : document;

    scope.querySelectorAll('.fv-banner-swiper__core').forEach(function (el) {
      if (el.swiper) {
        try {
          el.swiper.destroy(true, true);
        } catch (e) {
          /* 既に破棄済み等は無視 */
        }
      }
    });
  }

  function ensureSwiperAssetsThenInit(root) {
    if (window.Swiper) {
      initSwiperInScope(root);
      return;
    }

    var cssHref = 'https://cdn.jsdelivr.net/npm/swiper@9/swiper-bundle.min.css';
    if (!document.querySelector('link[href*="swiper-bundle.min.css"]')) {
      var link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = cssHref;
      document.head.appendChild(link);
    }

    var jsSrc = 'https://cdn.jsdelivr.net/npm/swiper@9/swiper-bundle.min.js';
    if (!document.querySelector('script[src*="swiper-bundle.min.js"]')) {
      var s = document.createElement('script');
      s.src = jsSrc;
      s.defer = true;
      s.onload = function () {
        initSwiperInScope(); // 初回ロードはページ全体を対象
      };
      document.head.appendChild(s);
    } else {
      if (typeof Swiper !== 'undefined') initSwiperInScope(root);
      else window.addEventListener('load', function () { initSwiperInScope(root); });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      ensureSwiperAssetsThenInit();
    });
  } else {
    ensureSwiperAssetsThenInit();
  }

  // テーマエディタ対応：変更・選択されたセクションだけを対象に再初期化する
  document.addEventListener('shopify:section:load', function (event) {
    ensureSwiperAssetsThenInit(event.target);
  });
  document.addEventListener('shopify:section:select', function (event) {
    ensureSwiperAssetsThenInit(event.target);
  });
  document.addEventListener('shopify:block:select', function (event) {
    var section = event.target && event.target.closest ? event.target.closest('[id^="shopify-section-"]') : null;
    if (section) ensureSwiperAssetsThenInit(section);
  });

  // セクションがテーマエディタ上で削除／差し替えられる直前に、古いインスタンスを明示的に破棄
  document.addEventListener('shopify:section:unload', function (event) {
    destroySwiperInScope(event.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fv-banner-swiper-milrty"] && !Shopify.designMode) return;
  try {
    
(function () {
  // 二重初期化・破棄済みインスタンスへの誤アクセスを防ぐための管理用マーカー
  var INIT_TOKEN_ATTR = 'data-fvswiper-token';
  var tokenCounter = 0;

  function initSwiperCore(el) {
    var wrapper = el.closest('.fv-banner-swiper');
    if (!wrapper) return;

    // 既存インスタンスがあれば先に破棄（テーマエディタでの再描画・並び替え後の多重初期化対策）
    if (el.swiper) {
      try {
        el.swiper.destroy(true, true);
      } catch (e) {
        /* 既に破棄済み等は無視 */
      }
    }

    tokenCounter += 1;
    var myToken = String(tokenCounter);
    el.setAttribute(INIT_TOKEN_ATTR, myToken);

    var paginationEl = wrapper.querySelector('.fv-banner-swiper__pagination');

    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        if (el.getAttribute(INIT_TOKEN_ATTR) !== myToken) return;
        if (!el.isConnected) return;

        buildSwiper(el, paginationEl);
      });
    });
  }

  function buildSwiper(el, paginationEl) {
    if (typeof Swiper === 'undefined') return;

    var slideCount = el.querySelectorAll('.swiper-slide').length;
    var useLoop = slideCount >= 2;

    new Swiper(el, {
      loop: useLoop,
      autoplay: useLoop
        ? {
            delay: 4000,
            disableOnInteraction: false,
            pauseOnMouseEnter: true
          }
        : false,

      speed: 600,
      slidesPerView: 1,
      spaceBetween: 0,

      // スライド間で画像の縦横比が異なってもコンテナ高さが自動追従する
      autoHeight: true,

      pagination: {
        el: paginationEl,
        clickable: true
      },

      watchSlidesProgress: true,
      observeParents: true,
      observer: true,
      observeSlideChildren: true,

      on: {
        init: function () {
          var self = this;
          requestAnimationFrame(function () {
            if (self.destroyed) return;
            self.update();
          });
        }
      }
    });
  }

  // root配下（省略時はdocument全体）の対象スライダーをすべて初期化する
  function initSwiperInScope(root) {
    if (typeof Swiper === 'undefined') return;
    var scope = root && root.querySelectorAll ? root : document;

    scope.querySelectorAll('.fv-banner-swiper__core').forEach(function (el) {
      initSwiperCore(el);
    });
  }

  // root配下のスライダーを明示的に破棄する（テーマエディタでセクションが差し替え／削除される直前用）
  function destroySwiperInScope(root) {
    var scope = root && root.querySelectorAll ? root : document;

    scope.querySelectorAll('.fv-banner-swiper__core').forEach(function (el) {
      if (el.swiper) {
        try {
          el.swiper.destroy(true, true);
        } catch (e) {
          /* 既に破棄済み等は無視 */
        }
      }
    });
  }

  function ensureSwiperAssetsThenInit(root) {
    if (window.Swiper) {
      initSwiperInScope(root);
      return;
    }

    var cssHref = 'https://cdn.jsdelivr.net/npm/swiper@9/swiper-bundle.min.css';
    if (!document.querySelector('link[href*="swiper-bundle.min.css"]')) {
      var link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = cssHref;
      document.head.appendChild(link);
    }

    var jsSrc = 'https://cdn.jsdelivr.net/npm/swiper@9/swiper-bundle.min.js';
    if (!document.querySelector('script[src*="swiper-bundle.min.js"]')) {
      var s = document.createElement('script');
      s.src = jsSrc;
      s.defer = true;
      s.onload = function () {
        initSwiperInScope(); // 初回ロードはページ全体を対象
      };
      document.head.appendChild(s);
    } else {
      if (typeof Swiper !== 'undefined') initSwiperInScope(root);
      else window.addEventListener('load', function () { initSwiperInScope(root); });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      ensureSwiperAssetsThenInit();
    });
  } else {
    ensureSwiperAssetsThenInit();
  }

  // テーマエディタ対応：変更・選択されたセクションだけを対象に再初期化する
  document.addEventListener('shopify:section:load', function (event) {
    ensureSwiperAssetsThenInit(event.target);
  });
  document.addEventListener('shopify:section:select', function (event) {
    ensureSwiperAssetsThenInit(event.target);
  });
  document.addEventListener('shopify:block:select', function (event) {
    var section = event.target && event.target.closest ? event.target.closest('[id^="shopify-section-"]') : null;
    if (section) ensureSwiperAssetsThenInit(section);
  });

  // セクションがテーマエディタ上で削除／差し替えられる直前に、古いインスタンスを明示的に破棄
  document.addEventListener('shopify:section:unload', function (event) {
    destroySwiperInScope(event.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fv-banner-swiper"] && !Shopify.designMode) return;
  try {
    
(function () {
  // 二重初期化・破棄済みインスタンスへの誤アクセスを防ぐための管理用マーカー
  var INIT_TOKEN_ATTR = 'data-fvswiper-token';
  var tokenCounter = 0;

  function initSwiperCore(el) {
    var wrapper = el.closest('.fv-banner-swiper');
    if (!wrapper) return;

    // 既存インスタンスがあれば先に破棄（テーマエディタでの再描画・並び替え後の多重初期化対策）
    if (el.swiper) {
      try {
        el.swiper.destroy(true, true);
      } catch (e) {
        /* 既に破棄済み等は無視 */
      }
    }

    tokenCounter += 1;
    var myToken = String(tokenCounter);
    el.setAttribute(INIT_TOKEN_ATTR, myToken);

    var paginationEl = wrapper.querySelector('.fv-banner-swiper__pagination');

    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        if (el.getAttribute(INIT_TOKEN_ATTR) !== myToken) return;
        if (!el.isConnected) return;

        buildSwiper(el, paginationEl);
      });
    });
  }

  function buildSwiper(el, paginationEl) {
    if (typeof Swiper === 'undefined') return;

    var slideCount = el.querySelectorAll('.swiper-slide').length;
    var useLoop = slideCount >= 2;

    new Swiper(el, {
      loop: useLoop,
      autoplay: useLoop
        ? {
            delay: 4000,
            disableOnInteraction: false,
            pauseOnMouseEnter: true
          }
        : false,

      speed: 600,
      slidesPerView: 1,
      spaceBetween: 0,

      // スライド間で画像の縦横比が異なってもコンテナ高さが自動追従する
      autoHeight: true,

      pagination: {
        el: paginationEl,
        clickable: true
      },

      watchSlidesProgress: true,
      observeParents: true,
      observer: true,
      observeSlideChildren: true,

      on: {
        init: function () {
          var self = this;
          requestAnimationFrame(function () {
            if (self.destroyed) return;
            self.update();
          });
        }
      }
    });
  }

  // root配下（省略時はdocument全体）の対象スライダーをすべて初期化する
  function initSwiperInScope(root) {
    if (typeof Swiper === 'undefined') return;
    var scope = root && root.querySelectorAll ? root : document;

    scope.querySelectorAll('.fv-banner-swiper__core').forEach(function (el) {
      initSwiperCore(el);
    });
  }

  // root配下のスライダーを明示的に破棄する（テーマエディタでセクションが差し替え／削除される直前用）
  function destroySwiperInScope(root) {
    var scope = root && root.querySelectorAll ? root : document;

    scope.querySelectorAll('.fv-banner-swiper__core').forEach(function (el) {
      if (el.swiper) {
        try {
          el.swiper.destroy(true, true);
        } catch (e) {
          /* 既に破棄済み等は無視 */
        }
      }
    });
  }

  function ensureSwiperAssetsThenInit(root) {
    if (window.Swiper) {
      initSwiperInScope(root);
      return;
    }

    var cssHref = 'https://cdn.jsdelivr.net/npm/swiper@9/swiper-bundle.min.css';
    if (!document.querySelector('link[href*="swiper-bundle.min.css"]')) {
      var link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = cssHref;
      document.head.appendChild(link);
    }

    var jsSrc = 'https://cdn.jsdelivr.net/npm/swiper@9/swiper-bundle.min.js';
    if (!document.querySelector('script[src*="swiper-bundle.min.js"]')) {
      var s = document.createElement('script');
      s.src = jsSrc;
      s.defer = true;
      s.onload = function () {
        initSwiperInScope(); // 初回ロードはページ全体を対象
      };
      document.head.appendChild(s);
    } else {
      if (typeof Swiper !== 'undefined') initSwiperInScope(root);
      else window.addEventListener('load', function () { initSwiperInScope(root); });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      ensureSwiperAssetsThenInit();
    });
  } else {
    ensureSwiperAssetsThenInit();
  }

  // テーマエディタ対応：変更・選択されたセクションだけを対象に再初期化する
  document.addEventListener('shopify:section:load', function (event) {
    ensureSwiperAssetsThenInit(event.target);
  });
  document.addEventListener('shopify:section:select', function (event) {
    ensureSwiperAssetsThenInit(event.target);
  });
  document.addEventListener('shopify:block:select', function (event) {
    var section = event.target && event.target.closest ? event.target.closest('[id^="shopify-section-"]') : null;
    if (section) ensureSwiperAssetsThenInit(section);
  });

  // セクションがテーマエディタ上で削除／差し替えられる直前に、古いインスタンスを明示的に破棄
  document.addEventListener('shopify:section:unload', function (event) {
    destroySwiperInScope(event.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      if (!this.header) return;

      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';

      this.headerBounds = {};
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      if (!this.header) return;
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, obs) => {
        this.headerBounds = entries[0].intersectionRect;
        obs.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((d) => d.close());
    }

    closeSearchModal() {
      // Dawn5カスタムでは details-modal が無い場合があるため null 安全化
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal && typeof this.searchModal.close === 'function') {
        this.searchModal.close(false);
      }
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
